import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import "./index.css";
import App from "./App";
import store from "./app/redux/store";
import "./app/assets/css/toi/common.css";
import { initAwsRum } from "./app/libs/awsRum";
// import { initClarity } from "./app/libs/clarity";

const root = ReactDOM.createRoot(document.getElementById("root"));

// AWS CloudWatch RUM (prod debugging: performance + JS errors + HTTP)
initAwsRum();

// Microsoft Clarity disabled
// const clarityId = process.env.REACT_APP_CLARITY_PROJECT_ID;
// const isProdEnv = process.env.REACT_APP_ENV === "production";
// if (clarityId && isProdEnv) {
//   initClarity(clarityId);
// }

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

if (process.env.REACT_APP_ENV !== "production") {
  // reportWebVitals(console.log);
}
